import React from 'react';

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, className = '' }) => {
  return (
    <div className={`min-h-screen ${className}`}>
      <div className="max-w-[1200px] mx-auto px-6">
        {children}
      </div>
    </div>
  );
};

export default Layout;